import styled from 'styled-components';
import { spacing, positioning } from 'ui/theme/utils';

export const Container = styled.div.attrs(({ children, wrapped }) => ({
  children: wrapped ? <div>{children}</div> : children, // adding a div wrapper is useful when having floating childrens
}))`
  display: flex;
  flex-direction: ${({ flexDirection = 'column' }) => flexDirection};
  flex-grow: ${({ flexGrow = 'initial' }) => flexGrow};
  align-items: ${({ alignItems = 'start' }) => alignItems};
  justify-content: ${({ justifyContent = 'initial' }) => justifyContent};
  width: ${({ width = '100%' }) => width};
  height: ${({ height = '100%' }) => height};
  ${({ minHeight }) => minHeight && `min-height: ${minHeight};`}
  ${({ maxHeight }) => maxHeight && `max-height: ${maxHeight};`}
  ${({ minWidth }) => minWidth && `min-width: ${minWidth};`}
  ${({ maxWidth }) => maxWidth && `max-width: ${maxWidth};`}
  overflow: ${({ overflow = 'initial' }) => overflow};
  ${({ gap, theme }) => gap && `gap: ${theme.spacing[gap] || gap};`}
  ${({ bg, theme }) => bg && `background-color: ${theme.colors[bg] || bg};`}
  ${({ borderRadius }) => borderRadius && `border-radius: ${borderRadius};`}
  ${({ boxShadow }) => boxShadow && `box-shadow: ${boxShadow};`}
  ${({ userSelect }) => userSelect && `user-select: ${userSelect};`}
  ${({ fontSize }) => fontSize && `font-size: ${fontSize};`}
  ${({ zIndex }) => zIndex && `z-index: ${zIndex};`}

  ${(props) => `
    ${spacing(props)}
    ${positioning(props)}
  `}
`;
